export const apiBaseUrl = "https://admin.myprega.com/api/v1";
export const webUrl = "/patient/Casepaper/";
export const webUrlDashboard = "/patient/Dashboard";
export const webUrlLogin = "/patient/Loginform";
export const webUrlGarbhsanskar = "/patient/Garbha_Sanskar";
